/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import PropTypes from 'prop-types';
import { getTranslation, TranslationProvider } from '@resy/ui-kitchen';
import PhoneImg from '../../images/generic-device.png';

import {
  DownloadAppleButton,
  DownloadAppleButtonFRCA,
  DownloadAppleButtonFRFR,
  DownloadGoogleButton,
  DownloadGoogleButtonFRCA,
  DownloadGoogleButtonFRFR,
} from '../../svg';

import './Download.scss';

const IOSDownloadAppIconMap = {
  'fr-fr': <DownloadAppleButtonFRFR />,
  'fr-ca': <DownloadAppleButtonFRCA />,
  'en-us': <DownloadAppleButton />,
};

const GooglePlayDownloadAppIconMap = {
  'fr-fr': <DownloadGoogleButtonFRFR />,
  'fr-ca': <DownloadGoogleButtonFRCA />,
  'en-us': <DownloadGoogleButton />,
};

const downloadPropTypes = {
  $translate: PropTypes.shape({
    proposedLanguage: PropTypes.func.isRequired,
    use: PropTypes.func.isRequired,
  }).isRequired,
};

const Download = ({
  $translate,
}) => {
  const language = $translate.proposedLanguage() || $translate.use();

  return (
    <article className="ResyDownload">
      <section className="ResyDownload__left">
        <TranslationProvider translationKey="next_favorite_restaurant">
          <h2 className="ResyDownload__header color--text-primary-contrast">
            Your next favorite restaurant is a few taps away.
          </h2>
        </TranslationProvider>

        <div className="ResyDownload__store-wrapper">
          <span className="ResyDownload__store">
            <a
              href="https://itunes.apple.com/app/apple-store/id866163372?pt=86835890&ct=resycom&mt=8"
              target="_blank"
              rel="noopener noreferrer"
              aria-label={getTranslation({
                translationKey: 'download_app_itunes',
                fallback: 'Download the Resy app from the iTunes app store',
              })}
            >
              <i className="ResyIcon">
                {IOSDownloadAppIconMap[language?.toLowerCase()] || <DownloadAppleButton />}
              </i>
            </a>
          </span>

          <span className="ResyDownload__store">
            <a
              href="https://play.google.com/store/apps/details?id=com.resy.android.prod&hl=en_US"
              target="_blank"
              rel="noopener noreferrer"
              aria-label={getTranslation({
                translationKey: 'download_app_google',
                fallback: 'Download the Resy app from the Google Play store',
              })}
            >
              <i className="ResyIcon">
                {GooglePlayDownloadAppIconMap[language?.toLowerCase()] || <DownloadGoogleButton />}
              </i>
            </a>
          </span>
        </div>
      </section>

      <section className="ResyDownload__right">
        <img className="phone" alt="" src={PhoneImg} />
      </section>
    </article>
  );
};

Download.propTypes = downloadPropTypes;

export { downloadPropTypes };
export default Download;
